import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Button } from '../ui/Button/Button';

interface Props {
  children: ReactNode;
}

interface State {
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = {};

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('App boundary caught error', error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="app-fatal">
        <section>
          <h1>Terminal runtime error</h1>
          <p>{this.state.error.message}</p>
          <Button variant="primary" onClick={() => window.location.reload()}>Reload</Button>
        </section>
      </div>
    );
  }
}
